<template>
  <div v-if="(user_accesses && userService.hasAccess(user_accesses, ['admin', 'view_client']))" class="p-grid crud-demo">
    <div class="p-col-12">
      <div class="card">
        <Toast/>
        <Toolbar class="p-mb-4 table-toolbar">
          <template slot="left">
            <!-- <Button label="New" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />-->
<!--            <Button label="Delete" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected"-->
<!--                    :disabled="!selectedCarparks || !selectedCarparks.length"/>-->
          </template>

          <template slot="right">
            <!-- <FileUpload mode="basic" accept="image/*" :maxFileSize="1000000" label="Import" chooseLabel="Import"
                        class="p-mr-2 p-d-inline-block" :disabled="true"/> -->
            <Button label="Export" icon="pi pi-upload" class="p-button-info" @click="exportCSV($event)"/>
          </template>
        </Toolbar>

        <DataTable ref="dt" :value="carparks" :selection.sync="selectedCarparks" dataKey="id" :paginator="true"
                   :rows="10" :filters="filters"
                   paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                   :rowsPerPageOptions="[5,10,25]"
                   currentPageReportTemplate="Showing {first} to {last} of {totalRecords} car parks">
          <template #header>
            <div class="table-header">
              <h5 class="p-m-0">Manage Car Parks</h5>
              <span class="p-input-icon-left">
                <i class="pi pi-search"/>
                <InputText v-model="filters['global']" placeholder="Search..."/>
              </span>
            </div>
          </template>

          <Column selectionMode="multiple" headerStyle="width: 4rem"></Column>
          <Column header="Image">
            <template #body="slotProps">
              <img @click="showGallery(slotProps.data)" :src="slotProps.data.images && slotProps.data.images.length > 0 ? slotProps.data.images[0].path : 'assets/layout/images/carparks/default.jpg'"
                   :alt="slotProps.data.name" class="product-image"/>
            </template>
          </Column>
          <Column field="code" header="Code" sortable></Column>
          <Column field="name" header="Name" sortable></Column>
          <!-- <Column field="company" header="Company" sortable></Column> -->
          <Column field="company" header="Company" sortable>
            <template #body="slotProps">
              <button class="p-link button-link" @click="editClient(slotProps.data.client_id)"><span>{{slotProps.data.company}}</span></button>
            </template>
          </Column>
        </DataTable>

        <div v-if="carparks == null" class="loader">
          <scale-out class="loader-style"></scale-out>
        </div>

        <Dialog :visible.sync="deleteCarparkDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="carpark">Are you sure you want to delete <b>{{carpark.name}}</b>?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteCarparkDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteCarpark"/>
          </template>
        </Dialog>

        <Dialog :visible.sync="deleteCarparksDialog" :style="{width: '450px'}" header="Confirm" :modal="true">
          <div class="confirmation-content">
            <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem"/>
            <span v-if="carpark">Are you sure you want to delete the selected car parks?</span>
          </div>
          <template #footer>
            <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteCarparksDialog = false"/>
            <Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteSelectedCarparks"/>
          </template>
        </Dialog>

        <Galleria :value="images" :responsiveOptions="responsiveOptions" :numVisible="7"
                  containerStyle="max-width: 850px"
                  :circular="true" :fullScreen="true" :showItemNavigators="true" :showThumbnails="false"
                  :visible.sync="displayGallery">
          <template #item="slotProps">
            <img :src="slotProps.item.itemImageSrc" :alt="slotProps.item.alt" style="width: 100%; display: block;"/>
          </template>
          <template #thumbnail="slotProps">
            <img :src="slotProps.item.thumbnailImageSrc" :alt="slotProps.item.alt" style="display: block;"/>
          </template>
        </Galleria>

      </div>
    </div>
  </div>

</template>

<script>
  import CarParkService from '../../services/CarParkService';
  import UserService from '../../services/UserService';
  import {ScaleOut} from 'vue-loading-spinner';

  export default {
    components: { ScaleOut },
    data() {
      return {
        carparks: null,
        carparkDialog: false,
        deleteCarparkDialog: false,
        deleteCarparksDialog: false,
        carpark: {},
        selectedCarparks: null,
        filters: {},
        submitted: false,
        displayGallery: false,
        images: [],
        responsiveOptions: [
          {
            breakpoint: '1024px',
            numVisible: 5
          },
          {
            breakpoint: '768px',
            numVisible: 3
          },
          {
            breakpoint: '560px',
            numVisible: 1
          }
        ],
        user_accesses: this.$store.state.accesses,
        userService: null,
        carparkService: null,
      }
    },
    created() {
      this.carparkService = new CarParkService();
      this.userService = new UserService();
      if (!this.user_accesses){
        let user_info = this.$store.state.user_info ? JSON.parse(this.$store.state.user_info) : {};
        this.userService.getUserAccesses(user_info.id).then(result => {
          if (result.status === 200) {
            let accesses = result.data.accesses;
            this.$store.state.accesses = accesses;
            this.user_accesses = accesses;
          }
        });
      }
    },
    mounted() {
      this.carparkService.listCarparks().then(response => this.carparks = response.data.carparks);
    },
    methods: {
      editClient(id) {
        localStorage.removeItem("client_info");
        this.$router.push('/client/edit/' + id).catch()
      },
      formatCurrency(value) {
        return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
      },
      showGallery(carpark) {
        this.carpark = this.carparks[this.findIndexById(carpark.id)];
        this.images = carpark.images ? carpark.images.map(image => {
          return {
            "itemImageSrc": image.path,
            "thumbnailImageSrc": image.path,
            "alt": image.name,
            "title": image.name
          }
        }) : [];
        this.displayGallery = !this.displayGallery;
      },
      hideDialog() {
        this.carparkDialog = false;
        this.submitted = false;
      },
      editCarpark(carpark) {
        this.carpark = {...carpark};
      },
      confirmDeleteCarpark(carpark) {
        this.carpark = carpark;
        this.deleteCarparkDialog = true;
      },
      deleteCarpark() {
        this.carparks = this.carparks.filter(val => val.id !== this.carpark.id);
        this.deleteCarparkDialog = false;
        this.carpark = {};
        this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Car Park Deleted', life: 3000});
      },
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.carparks.length; i++) {
          if (this.carparks[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      exportCSV() {
        this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteCarparksDialog = true;
      },
      deleteSelectedCarparks() {
        this.carparks = this.carparks.filter(val => !this.selectedCarparks.includes(val));
        this.deleteCarparksDialog = false;
        this.selectedCarparks = null;
        this.$toast.add({severity: 'success', summary: 'Successful', detail: 'Car Parks Deleted', life: 3000});
      }
    }
  }
</script>

<style scoped lang="scss">
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .product-image {
    width: 100px;
    border-radius: 2em;

    &:hover {
      cursor: pointer;
    }

    /*box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);*/
  }

  .p-dialog .product-image {
    width: 150px;
    margin: 0 auto 2rem auto;
    display: block;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .product-badge {
    border-radius: 2px;
    padding: .25em .5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: .3px;

    &.status-active {
      background: #C8E6C9;
      color: #256029;
    }

    &.status-inactive {
      background: #FFCDD2;
      color: #C63737;
    }
  }
</style>
